import React, { useState, useEffect, useMemo, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEdit,
  faFileCsv,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import Select from '../Group/Select'
import Search from '../Search'
import { Button, Col, Input, Row } from 'reactstrap'
import DefaultModal from '../Modal'
import { Content } from '../Overlay'
import { useDispatch, useSelector } from 'react-redux'
import { onClickSearch } from 'store/Course/actions'
import {
  selectGroup,
  selectLocation,
  selectCoursesRole,
  saveCoursesFilter,
  saveEditedFilter,
  deleteSavedFilter,
  selectEditGroupAndLocationsExternalReports,
  setShowExternalReportsFiltersOverlay,
  selectExternalReportsSavedFilter,
  selectGroupsLocationGroupCourse,
  selectCoursesRoleCourseManager,
  selectGroupsRoleCourseManager,
  selectExternalReportsGroup,
  selectExternalReportsLocation,
  selectEditGroupAndLocations,
  clearGroupsFilter,
  selectCategory,
  selectGroupsGroup,
  selectGroupsLocation,
  selectGroupsRole,
  setGroupsFilter,
  saveGroupsFilter,
  saveEditedGroupsFilter,
  editCourseGroupFilter,
  clearCoursesFilter,
  selectExternalReportsRole,
  clearExternalReportsFilter,
  saveExternalReportsFilter,
  setExternalReportsFilter,
  selectCoursesSavedFilter,
  selectGroupsSavedFilter,
  setSearchByData,
  setSearchByCore,
  setSearchByHeader,
  selectCourseManagerGroupsLocationGroupCourse,
  onClickCourseManagerExportTrainingButton,
  setShowCoursesFiltersOverlay,
  setCoursesFilter,
  setShowGroupsFiltersOverlay,
  onClickExportButton,
  search,
} from 'store/ManagerReport/actions'
import { onClickExportTrainingButton } from 'store/ManagerReport/actions'
import { onClickExportExternalReportsButton } from 'store/ManagerReport/actions'
import { selectGroups } from 'store/ManagerReport/actions'
import { selectGroupsGroups } from 'store/ManagerReport/actions'
import { selectExternalReportsGroups } from 'store/ManagerReport/actions'
import { saveEditedExternalReportFilter } from 'store/ManagerReport/actions'
import { enableCursor } from '@fullcalendar/core'
import { fetchLocationGroups } from 'store/ManagerReport/actions'
import { fetchStores } from 'store/Stores/actions'

// import {
//   fetchGroupLocations,
//   fetchCoreGroupCourses,
//   fetchGroups,
//   fetchRoles,
//   fetchLocations,
// } from 'store/Group/actions'
// import {
//   faChevronLeft,
//   faChevronRight,
// } from '@fortawesome/free-solid-svg-icons'

// import {
//   fetchCategories,
//   getCourseManagerCoursesModule,
//   addToBreadcrumb,
//   onResetSearch,
//   setManagerId,
//   setCoursesUpdated,
//   fetchRolesCounts,
//   fetchUsersSavedFilters,
//   setExternalReportsUpdated,
//   setExternalReportsFocusedCell,
//   setExternalReportsRows,
//   setExternalReportsColumnDefs,
//   setGroupsUpdated,
//   setGroupsRows,
//   setGroupsFocusedCell,
//   setGroupsColumnDefs,
//   setCoursesRows,
//   setCoursesFocusedCell,
//   setCoursesColumnDefs,
//   setSelectedTab,
// } from 'store/ManagerReport/actions'
// import { fetchAllStores, fetchStores } from 'store/Stores/actions'

// import { formatRows, formatColumns } from './DataConfig'
// import { AgGridReact } from 'ag-grid-react'

// import Chart from '../Charts/index'
// import Header from './Header'

const sortByName = (array, allLabel = false) => {
  if (!Array.isArray(array)) {
    return array
  }

  let filteredArray = array.filter(
    (option) => option.id !== null && option.name !== null
  )

  let allObject = []
  if (allLabel && filteredArray.length) {
    allObject = [{ id: 'all', name: 'All' }]
  }

  const sortedArray = filteredArray.sort((a, b) => {
    if (
      a.name &&
      b.name &&
      a.name.trim().toLowerCase() > b.name.trim().toLowerCase()
    ) {
      return 1
    }
    return -1
  })

  return [...allObject, ...sortedArray]
}

const FilterWrapperCourses = (props) => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const { stores } = useSelector((store) => store.stores)
  const language = languageRedux || {}

  const dispatch = useDispatch()
  const {
    filterType,
    filterName,
    item,
    setFilterName,
    setItem,
    edit,
    setEdit,
    managerReport,
  } = props

  useEffect(() => {
    if (!managerReport.selectedCategories) {
      dispatch(fetchLocationGroups())
    }
  }, [dispatch, managerReport.selectedCategories])

  // useEffect(() => {
  //   if (!stores && !stores?.length) {
  //     console.log('leart163')
  //     dispatch(fetchStores())
  //   }
  // }, [stores, dispatch])

  console.log(stores, 'leart169')

  return (
    <div className='filters-wrapper'>
      <div
        className='cancel-edit__div'
        onClick={filterType === 1 ? dispatch(clearCoursesFilter()) : null}
      >
        <p
          onClick={edit === 1 ? () => setEdit(0) : null}
          className={edit === 0 ? 'mb-1' : 'cancel-edit__btn'}
        >
          {edit === 0
            ? `${
                language.manager_report
                  ? language.manager_report.select_filters
                  : 'Select Filters:'
              }:`
            : `Cancel Edit`}
        </p>
      </div>
      <div className='filter-type'>
        {edit === 1 ? `Editing Filter: ${filterName}` : ''}
      </div>

      <Row>
        <div className='col-md-6 multiline-wrapper mb-2 '>
          <Select
            options={sortByName(managerReport.categories)}
            selectedOptions={managerReport.selectedCategories || null}
            Categories
            onChange={(e) => dispatch(selectCategory(e))}
            placeholder={
              language.settings ? language.settings.categories : 'Categories'
            }
            multi={false}
            valueKey={'name'}
          />
        </div>
        <div className='col-md-6 multiline-wrapper mb-2'>
          <Select
            options={sortByName(managerReport?.areas, true)}
            selectedOptions={managerReport.selectedCoursesGroups || null}
            onChange={(e) => {
              return dispatch(selectGroups(e, props?.storesState))
            }}
            placeholder={
              language.manager_report
                ? language.manager_report.select_group
                : 'Select Group'
            }
            valueKey={'name'}
          />
        </div>
      </Row>

      <Row>
        <div
          className={`col-md-6 mb-2 ${
            props.type === 'groups'
              ? 'multiline-wrapper-groups'
              : 'multiline-wrapper'
          }`}
        >
          {console.log(managerReport.groupLocations, 'leart232')}
          <Select
            options={
              managerReport.selectedCoursesGroups
                ? sortByName(managerReport?.groupLocations, true)
                : []
            }
            selectedOptions={managerReport.selectedCoursesLocations || null}
            onChange={(e) => {
              dispatch(selectLocation(e))
            }}
            placeholder={
              language.manager_report
                ? language.manager_report.select_location
                : 'Select Location'
            }
            isDisabled={managerReport.selectedCoursesGroups ? false : true}
          />
        </div>
        <div className='col-md-6 mb-2 multiline-wrapper'>
          <Select
            options={
              managerReport.selectedCoursesGroups &&
              managerReport.selectedCoursesLocations.length &&
              managerReport.rolesCount
                ? sortByName(managerReport?.rolesCount, true)
                : []
            }
            selectedOptions={managerReport.selectedCoursesRole || []}
            onChange={(e) => dispatch(selectCoursesRole(e))}
            multi={true}
            placeholder={
              language.manager_report
                ? language.manager_report.select_role
                : 'Select Role'
            }
            isDisabled={
              managerReport.selectedCoursesLocations.length ? false : true
            }
          />
        </div>
      </Row>

      <div className='leon'>
        <span className='col7 lg-col0'></span>
        <span className='col5 lg-col12 leon gap06 mt-3'>
          <Button
            size='sm'
            className={`btn btn-clear-filters py-2 mx-0 col4
          ${
            managerReport.selectedCategories ||
            managerReport.selectedCoursesGroups ||
            managerReport.selectedCoursesLocations.length ||
            managerReport.selectedCoursesRole.length ||
            managerReport.selectedCoursesSavedFilter
              ? ''
              : 'btn-disabled'
          }`}
            disabled={
              managerReport.selectedCategories ||
              managerReport.selectedCoursesGroups ||
              managerReport.selectedCoursesLocations.length ||
              managerReport.selectedCoursesRole.length ||
              managerReport.selectedCoursesSavedFilter
                ? false
                : true
            }
            onClick={() => dispatch(clearCoursesFilter())}
          >
            {language.manager_report
              ? language.manager_report.clear_filters
              : 'Clear filters'}
          </Button>
          <Button
            size='sm'
            className={`btn btn-info mx-0 py-2 col4
          ${
            managerReport.selectedCategories ||
            (managerReport.selectedCoursesGroups &&
              managerReport.selectedCoursesLocations.length)
              ? ''
              : 'btn-disabled'
          }`}
            onClick={() => dispatch(setCoursesFilter())}
            disabled={
              managerReport.selectedCategories ||
              (managerReport.selectedCoursesGroups &&
                managerReport.selectedCoursesLocations.length)
                ? false
                : true
            }
          >
            {language.manager_report
              ? language.manager_report.apply_filters
              : 'Apply filters'}
          </Button>
          <Button
            size='sm'
            className={`btn  btn-info btn-save-filter mx-0 py-2 col4
          ${
            managerReport.selectedCategories ||
            (managerReport.selectedCoursesGroups &&
              managerReport.selectedCoursesLocations.length)
              ? ''
              : 'btn-disabled'
          }`}
            onClick={
              edit === 0
                ? () => dispatch(saveCoursesFilter())
                : () => dispatch(saveEditedFilter(item))
            }
            disabled={
              managerReport.selectedCategories ||
              (managerReport.selectedCoursesGroups &&
                managerReport.selectedCoursesLocations.length)
                ? false
                : true
            }
          >
            {language.manager_report
              ? language.manager_report.save_filter
              : 'Save Filter'}
          </Button>
        </span>
      </div>

      <Row className='ml-0 mr-0 mt-2'>
        <p>
          {language.manager_report
            ? language.manager_report.saved_filters
            : 'Saved filters:'}
          :
        </p>
      </Row>

      <Row className='ml-0 mr-0'>
        <div className='course-list-wrapper w-100'>
          {managerReport.savedCoursesFilters.length ? (
            managerReport.savedCoursesFilters.map((item) => (
              <div className='course-row saved-filters' key={item.id}>
                <p className='mb-0 col-9'>{item.name}</p>
                <div className='col-3 saved-filters__options'>
                  <button
                    key={item.id}
                    className='btn actionIcon '
                    onClick={() => {
                      dispatch(selectEditGroupAndLocations(item, props.roles))
                      setEdit(1)
                      setItem(item)
                      setFilterName(item.name)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className='far edit-filter__btn'
                      data-prefix='far'
                    />
                  </button>
                  <button
                    onClick={() =>
                      dispatch(deleteSavedFilter(item.id, item.name))
                    }
                    title={`Delete`}
                    className='btn actionIconDelete'
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className='far' />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <label className='latest-update'>No saved filters</label>
          )}
        </div>
      </Row>
    </div>
  )
}

const FilterWrapperCourseGroups = (props) => {
  const dispatch = useDispatch()
  const managerReport = useSelector((state) => state.managerReport)

  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  const {
    filterType,
    filterName,
    item,
    setFilterType,
    setFilterName,
    setItem,
  } = props

  return (
    <div className='filters-wrapper'>
      <div
        className='cancel-edit__div'
        onClick={
          filterType === 1 ? () => dispatch(clearGroupsFilter()) : () => {}
        }
      >
        <p
          onClick={filterType === 1 ? () => setFilterType(0) : () => {}}
          className={filterType === 0 ? 'mb-1' : 'cancel-edit__btn'}
        >
          {filterType === 0 ? 'Select filters: ' : `Cancel Edit`}
        </p>
      </div>
      <div className='filter-type'>
        {filterType === 1 ? `Editing Filter: ${filterName}` : ''}
      </div>
      <Row>
        <div className='col-md-6 multiline-wrapper mb-2'>
          <Select
            options={sortByName(managerReport.categories)}
            selectedOptions={managerReport.selectedCategories || null}
            onChange={(e) => dispatch(selectCategory(e))}
            placeholder={
              language.settings ? language.settings.categories : 'Categories'
            }
            multi={false}
            valueKey={'name'}
            language={language}
          />
        </div>
        <div className='col-md-6 multiline-wrapper mb-2'>
          <Select
            options={sortByName(managerReport.areas, true)}
            selectedOptions={managerReport.selectedGroupsGroups || null}
            onChange={(e) => dispatch(selectGroupsGroups(e))}
            placeholder={
              language.manager_report
                ? language.manager_report.select_group
                : 'Select Group'
            }
            valueKey={'name'}
          />
        </div>
        <div
          className={`col-md-6 mb-2 ${
            props.type === 'groups' ? 'multiline-wrapper' : 'multiline-wrapper'
          }`}
        >
          <Select
            options={
              managerReport.selectedGroupsGroups
                ? sortByName(managerReport?.groupGroupsLocations, true)
                : []
            }
            selectedOptions={managerReport.selectedGroupsLocations || null}
            onChange={(e) => dispatch(selectGroupsLocation(e))}
            placeholder={
              language.manager_report
                ? language.manager_report.select_location
                : 'Select Location'
            }
            // language={props.language}
          />
        </div>
        <div
          className={`col-md-6 mb-2 ${
            props.type === 'groups' ? 'multiline-wrapper' : 'multiline-wrapper'
          }`}
        >
          <Select
            options={
              managerReport.selectedGroupsGroups
                ? sortByName(managerReport.locationGroupCourses)
                : []
            }
            selectedOptions={managerReport.selectedGroupGroupsLocations || null}
            onChange={(e) => dispatch(selectGroupsLocationGroupCourse(e))}
            placeholder={'Select Curriculum'}
            // language={props.language}
            multi={false}
          />
        </div>
        <div className='col-md-6 multiline-wrapper mb-2'>
          <Select
            options={
              managerReport.selectedGroupsGroups &&
              (managerReport.selectedGroupsLocations.length ||
                managerReport.selectedGroupGroupsLocations) &&
              managerReport.rolesCount
                ? sortByName(managerReport?.rolesCount, true)
                : []
            }
            selectedOptions={managerReport.selectedGroupsRole || []}
            onChange={(e) => dispatch(selectGroupsRole(e))}
            placeholder={'Select Role'}
          />
        </div>
      </Row>
      <div className='mt-2 align-content-right'>
        <Button
          size='sm'
          className={`btn btn-clear-filters 
          ${
            managerReport.selectedCategories ||
            managerReport.selectedGroupsGroup ||
            managerReport.selectedGroupsLocations.length ||
            managerReport.selectedGroupGroupsLocations ||
            managerReport.selectedGroupsRole.length ||
            managerReport.selectedGroupsSavedFilter
              ? ''
              : 'btn-disabled'
          }`}
          disabled={
            managerReport.selectedCategories ||
            managerReport.selectedGroupsGroup ||
            managerReport.selectedGroupsLocations.length ||
            managerReport.selectedGroupGroupsLocations ||
            managerReport.selectedGroupsRole.length ||
            managerReport.selectedGroupsSavedFilter
              ? false
              : true
          }
          onClick={() => dispatch(clearGroupsFilter())}
        >
          Clear filters
        </Button>
        <Button
          size='sm'
          className={`btn btn-info
          ${
            managerReport.selectedGroupsGroups &&
            managerReport.selectedGroupGroupsLocations
              ? ''
              : 'btn-disabled'
          }`}
          onClick={() => dispatch(setGroupsFilter())}
          disabled={
            managerReport.selectedGroupsGroups &&
            managerReport.selectedGroupGroupsLocations
              ? false
              : true
          }
        >
          Apply filters
        </Button>
        <Button
          size='sm'
          className={`btn btn-info
          ${
            managerReport.selectedGroupsGroups &&
            managerReport.selectedGroupGroupsLocations
              ? ''
              : 'btn-disabled'
          }`}
          onClick={
            filterType === 0
              ? () => dispatch(saveGroupsFilter())
              : () => dispatch(saveEditedGroupsFilter(item))
          }
          disabled={
            managerReport.selectedGroupsGroups &&
            managerReport.selectedGroupGroupsLocations
              ? false
              : true
          }
        >
          Save filters
        </Button>
      </div>
      <Row className='ml-0 mr-0 mt-2'>
        <p>Saved filters:</p>
      </Row>
      <Row className='ml-0 mr-0'>
        <div className='course-list-wrapper w-100'>
          {managerReport.savedGroupsFilters.length ? (
            managerReport.savedGroupsFilters.map((item) => (
              <div className='course-row saved-filters' key={item.id}>
                <p className='mb-0 col-9'>{item.name}</p>
                <div className='col-3 saved-filters__options'>
                  <button
                    onClick={() => dispatch(deleteSavedFilter(item.id))}
                    title={`Delete`}
                    className='btn btn-transparent shadow-none'
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className='far' />
                  </button>

                  <span
                    className='edit-filter__div'
                    onClick={() => {
                      dispatch(editCourseGroupFilter(item, props.roles))
                      setFilterType(1)
                      setItem(item)
                      setFilterName(item.name)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className='far edit-filter__btn'
                      data-prefix='far'
                    />
                  </span>
                </div>
              </div>
            ))
          ) : (
            <label className='latest-update'>No saved filters</label>
          )}
        </div>
      </Row>
    </div>
  )
}

const FilterWrapperExternalReports = (props) => {
  const dispatch = useDispatch()
  const managerReport = useSelector((state) => state.managerReport)
  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  useEffect(() => {
    console.log('🕴🏿 GROUPS', managerReport.selectedExternalReportsGroups)
    console.log('🕴🏿LOCATIONS', managerReport.selectedExternalReportsLocations)
  }, [
    managerReport.selectedExternalReportsGroups,
    managerReport.selectedExternalReportsLocations,
  ])

  const {
    filterType,
    filterName,
    item,
    setFilterType,
    setFilterName,
    setItem,
  } = props
  return (
    <div className=' filters-wrapper'>
      <div
        className='cancel-edit__div'
        onClick={
          filterType === 1 ? () => dispatch(clearExternalReportsFilter()) : null
        }
      >
        <p
          onClick={filterType === 1 ? () => setFilterType(0) : null}
          className={filterType === 0 ? 'mb-1' : 'cancel-edit__btn'}
        >
          {filterType === 0 ? 'Select Filters' : `Cancel Edit`}
        </p>
      </div>
      <div className='filter-type'>
        {filterType === 1 ? `Editing Filter: ${filterName}` : ''}
      </div>

      <Row>
        <div className='col-md-6 mb-2 multiline-wrapper'>
          {/* <Select
            options={sortByName(managerReport.categories)}
            selectedOptions={managerReport.selectedCategories || null}
            onChange={(e) => dispatch(selectCategory(e))}
            placeholder={'Categories'}
            multi={false}
            valueKey={'name'}
          /> */}
          <Select
            options={sortByName(managerReport.categories)}
            selectedOptions={managerReport.selectedCategories || null}
            onChange={(e) => dispatch(selectCategory(e))}
            placeholder={
              language.settings ? language.settings.categories : 'Categories'
            }
            multi={false}
            valueKey={'name'}
            language={language}
          />
        </div>

        <div className='col-md-6 mb-2 multiline-wrapper'>
          <Select
            options={sortByName(managerReport.areas, true)}
            selectedOptions={
              managerReport.selectedExternalReportsGroups || null
            }
            onChange={(e) => dispatch(selectExternalReportsGroups(e))}
            placeholder={
              language.manager_report
                ? language.manager_report.select_group
                : 'Select Group'
              // Select Areas
            }
            valueKey={'name'}
          />
        </div>
      </Row>

      <Row>
        <div
          className={`col-md-6 mb-2${
            props.type === 'groups'
              ? 'multiline-wrapper-groups'
              : 'multiline-wrapper'
          }`}
        >
          {/* <Select
            options={
              managerReport.selectedGroupsGroups
                ? sortByName(managerReport?.groupGroupsLocations, true)
                : []
            }
            selectedOptions={managerReport.selectedGroupsLocations || null}
            onChange={(e) => dispatch(selectGroupsLocation(e))}
            placeholder={
              language.manager_report
                ? language.manager_report.select_location
                : 'Select Location'
            }
            // language={props.language}
          /> */}
          <Select
            options={
              managerReport.selectedExternalReportsGroups
                ? sortByName(managerReport?.groupLocations, true)
                : []
            }
            selectedOptions={
              managerReport.selectedExternalReportsLocations || null
            }
            onChange={(e) => dispatch(selectExternalReportsLocation(e))}
            placeholder={
              language.manager_report
                ? language.manager_report.select_location
                : 'Select Location'
              // Select Store
            }
            // language={props.language}
          />
        </div>
        <div className='col-md-6 mb-2 multiline-wrapper'>
          <Select
            options={
              managerReport.selectedGroupsGroups &&
              (managerReport.selectedGroupsLocations.length ||
                managerReport.selectedGroupGroupsLocations) &&
              managerReport.rolesCount
                ? sortByName(managerReport?.rolesCount, true)
                : []
            }
            selectedOptions={managerReport.selectedGroupsRole || []}
            onChange={(e) => dispatch(selectGroupsRole(e))}
            placeholder={'Select Role'}
          />
        </div>
      </Row>

      <div className='mt-2 align-content-right'>
        <Button
          size='sm'
          className={`btn  btn-clear-filters 
			${
        managerReport.selectedCategories ||
        managerReport.selectedExternalReportsGroups ||
        managerReport.selectedExternalReportsLocations.length ||
        managerReport.selectedExternalReportsRole.length ||
        managerReport.selectedExternalReportsSavedFilter
          ? ''
          : 'btn-disabled'
      }`}
          disabled={
            managerReport.selectedCategories ||
            managerReport.selectedExternalReportsGroups ||
            managerReport.selectedExternalReportsLocations.length ||
            managerReport.selectedExternalReportsRole.length ||
            managerReport.selectedExternalReportsSavedFilter
              ? false
              : true
          }
          onClick={() => dispatch(clearExternalReportsFilter())}
        >
          Clear Filters
        </Button>
        <Button
          size='sm'
          className={`btn  btn-info
		  ${
        managerReport.selectedExternalReportsGroups &&
        managerReport.selectedExternalReportsLocations.length
          ? ''
          : 'btn-disabled'
      }`}
          onClick={() => dispatch(setExternalReportsFilter())}
          disabled={
            managerReport.selectedExternalReportsGroups &&
            managerReport.selectedExternalReportsLocations.length
              ? false
              : true
          }
        >
          Apply Filters
        </Button>
        <Button
          size='sm'
          className={`btn  btn-info btn-save-filter
			  ${
          managerReport.selectedExternalReportsGroups &&
          managerReport.selectedExternalReportsLocations.length
            ? ''
            : 'btn-disabled'
        }`}
          onClick={
            filterType === 0
              ? () => dispatch(saveExternalReportsFilter())
              : () => dispatch(saveEditedExternalReportFilter(item))
          }
          disabled={
            managerReport.selectedExternalReportsGroups &&
            managerReport.selectedExternalReportsLocations.length
              ? false
              : true
          }
        >
          Save Filter
        </Button>
      </div>

      <div className='ml-0 mr-0 mt-2'>
        <p>Saved Filters :</p>
      </div>

      <Row className='ml-0 mr-0'>
        <div className='course-list-wrapper w-100'>
          {managerReport?.savedExternalReportsFilters?.length ? (
            managerReport.savedExternalReportsFilters.map((item) => (
              <div className='course-row saved-filters' key={item.id}>
                <p className='mb-0 col-9'>{item.name}</p>
                <div className='col-3 saved-filters__options'>
                  <button
                    onClick={() => dispatch(deleteSavedFilter(item.id))}
                    title={`Delete`}
                    className='btn  btn-transparent shadow-none'
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className='far' />
                  </button>
                  <span
                    className='edit-filter__div'
                    onClick={() => {
                      dispatch(
                        selectEditGroupAndLocationsExternalReports(
                          item,
                          props.roles
                        )
                      )
                      setFilterType(1)
                      setItem(item)
                      setFilterName(item.name)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className='far edit-filter__btn'
                      data-prefix='far'
                    />
                  </span>
                </div>
              </div>
            ))
          ) : (
            <label className='latest-update'>No saved filters</label>
          )}
        </div>
        {/* </div> */}
      </Row>
    </div>
  )
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch()
  const managerReport = useSelector((state) => state.managerReport)
  const user = useSelector((state) => state.auth.user)
  const [filterType, setFilterType] = useState(0)
  const [item, setItem] = useState(null)
  const [filterName, setFilterName] = useState('')
  const [filterModal, setFilterModal] = useState(false)
  const [edit, setEdit] = useState(0)

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const [showingChart, setShowingChart] = useState(false)
  const { exportButton, exportTrainingButton } = managerReport

  const activateCharts = exportButton || exportTrainingButton ? true : false
  const [managerUsers, setManagerUsers] = useState([])

  const setApprovalModal = (isOpen) => {
    setFilterModal(isOpen)
  }

  const handleExportButtonClick = () => {
    if (managerReport.exportButton) {
      dispatch(onClickExportButton())
    }
  }

  const handleExportTrainingButtonClick = () => {
    if (managerReport.exportTrainingButton) {
      dispatch(onClickExportTrainingButton())
    }
  }

  const handleExportExternalReportsButtonClick = () => {
    if (managerReport.exportExternalReportsButton) {
      dispatch(onClickExportExternalReportsButton())
    }
  }

  return (
    <Col>
      <Row className='justify-content-between px-0 px-lg-3 align-items-center'>
        <div className='d-flex col-md-8 col-sm-12 px-0'>
          <div
            className={
              (managerReport.selectedTab === 'courses' ||
                managerReport.selectedTab === 'groups' ||
                managerReport.selectedTab === 'external-reports') &&
              (user.access === 1 ||
                user.access === 4 ||
                user.access === 5 ||
                user.second_access === 4)
                ? ''
                : // ? "col-xl-1 col-lg-1 pl-0 col-sm-2"
                  'col-md-9 col-sm-9 col-xl-9'
            }
          >
            {/* Filter button in courses */}
            <div className='steps-wrapper'>
              {managerReport.selectedTab === 'courses' &&
              (user.access === 1 ||
                user.access === 4 ||
                user.access === 5 ||
                user.second_access === 4) ? (
                <button
                  title={`Export to .csv`}
                  className='btn btn-info filters__button shadow-none'
                  onClick={() => {
                    setApprovalModal(true)
                    dispatch(setShowCoursesFiltersOverlay(true))
                  }}
                >
                  {language.manager_report
                    ? language.manager_report.filters
                    : 'Filters'}
                </button>
              ) : null}

              {/*Modal in courses */}
              {managerReport.coursesFilterOveralyShowing && filterModal ? (
                <DefaultModal
                  isOpen={filterModal}
                  setApprovalModal={setApprovalModal}
                  selectedTab={managerReport.selectedTab}
                  title='Filters'
                >
                  {/* <div> */}
                  <Content style={{ overflow: 'hidden' }}>
                    {managerReport.selectedTab === 'courses' &&
                    (user.access === 1 ||
                      user.access === 5 ||
                      user.second_access === 5) ? (
                      <FilterWrapperCourses
                        {...props}
                        filterType={filterType}
                        filterName={filterName}
                        item={item}
                        setFilterName={setFilterName}
                        setFilterType={setFilterType}
                        edit={edit}
                        setEdit={setEdit}
                        setItem={setItem}
                        managerReport={managerReport}
                      />
                    ) : null}

                    {managerReport.selectedTab === 'courses' &&
                    (user.access === 4 || user.second_access === 4) ? (
                      <div className='overlay-content filters-wrapper'>
                        <div
                          onClick={
                            filterType === 1
                              ? () => dispatch(clearCoursesFilter())
                              : null
                          }
                        >
                          <p
                            onClick={
                              filterType === 1 ? () => setFilterType(0) : null
                            }
                            className={
                              filterType === 0
                                ? 'mr-courses-select-filters'
                                : 'btn-info'
                            }
                          >
                            {filterType === 0
                              ? 'Select filters'
                              : `Cancel Edit`}
                          </p>
                        </div>
                        <div className='filter-type'>
                          {filterType === 1
                            ? `Editing Filter: ${filterName}`
                            : ''}
                        </div>
                        <div className='row filters-content'>
                          <div className='col-md-3'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={sortByName(managerReport.areas)}
                                selectedOptions={
                                  managerReport.selectedCoursesGroup || null
                                }
                                onChange={(e) => dispatch(selectGroup(e))}
                                placeholder={'Select group'}
                                multi={false}
                                valueKey={'name'}
                              />
                            </div>
                          </div>

                          <div className='col-md-5'>
                            <div
                              className={`${
                                props.type === 'groups'
                                  ? 'multiline-wrapper'
                                  : 'multiline-wrapper'
                              }`}
                            >
                              <Select
                                options={
                                  managerReport.selectedCoursesGroup
                                    ? managerReport.groupLocations
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedCoursesLocations || null
                                }
                                onChange={(e) => dispatch(selectLocation(e))}
                                placeholder={'Select location'}
                                // language={props.language}
                              />
                            </div>
                          </div>

                          <div className='col-md-4'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={
                                  managerReport.selectedCoursesGroup &&
                                  managerReport.selectedCoursesLocations.length
                                    ? managerReport.rolesCount
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedCoursesRole || []
                                }
                                onChange={(e) => dispatch(selectCoursesRole(e))}
                                placeholder={'Select role'}
                              />
                            </div>
                          </div>
                        </div>
                        <Row>
                          <div className='mt-2 align-content-right'>
                            <button
                              className={`btn  btn-clear-filters 
                                    ${
                                      managerReport.selectedCoursesGroup ||
                                      managerReport.selectedCoursesLocations
                                        .length ||
                                      managerReport.selectedCoursesRole
                                        .length ||
                                      managerReport.selectedCoursesSavedFilter
                                        ? ''
                                        : 'btn-disabled'
                                    }`}
                              disabled={
                                managerReport.selectedCoursesGroup ||
                                managerReport.selectedCoursesLocations.length ||
                                managerReport.selectedCoursesRole.length ||
                                managerReport.selectedCoursesSavedFilter
                                  ? false
                                  : true
                              }
                              onClick={() => dispatch(clearCoursesFilter())}
                            >
                              Clear filters
                            </button>
                            <button
                              className={`btn  btn-info
                                  ${
                                    managerReport.selectedCoursesGroup &&
                                    managerReport.selectedCoursesLocations
                                      .length
                                      ? ''
                                      : 'btn-disabled'
                                  }`}
                              onClick={props.setCoursesFilter}
                              disabled={
                                managerReport.selectedCoursesGroup &&
                                managerReport.selectedCoursesLocations.length
                                  ? false
                                  : true
                              }
                            >
                              Apply filters
                            </button>
                            <button
                              className={`btn  btn-info btn-save-filter
                                      ${
                                        managerReport.selectedCoursesGroup &&
                                        managerReport.selectedCoursesLocations
                                          .length
                                          ? ''
                                          : 'btn-disabled'
                                      }`}
                              onClick={
                                filterType === 0
                                  ? props.saveCoursesFilter
                                  : () => props.saveEditedFilter(item)
                              }
                              disabled={
                                managerReport.selectedCoursesGroup &&
                                managerReport.selectedCoursesLocations.length
                                  ? false
                                  : true
                              }
                            >
                              Save filter
                            </button>
                          </div>
                          <Row className='ml-0 mr-0 mt-2'>
                            <p>Saved filters:</p>
                          </Row>
                          <Row>
                            <div className='course-list-wrapper w-100'>
                              {managerReport.savedCoursesFilters.length ? (
                                managerReport.savedCoursesFilters.map(
                                  (item) => (
                                    <div className='course-row' key={item.id}>
                                      <p className='mb-0'>{item.name}</p>
                                      <div className='course-item-options'>
                                        <button
                                          onClick={() =>
                                            dispatch(deleteSavedFilter(item.id))
                                          }
                                          title={`Delete`}
                                          className='btn btn-transparent'
                                        >
                                          <FontAwesomeIcon
                                            icon={faTrashAlt}
                                            className=' far'
                                          />
                                        </button>
                                        <span
                                          onClick={() => {
                                            dispatch(
                                              selectEditGroupAndLocations(
                                                item,
                                                props.roles
                                              )
                                            )
                                            setFilterType(1)
                                            setItem(item)
                                            setFilterName(item.name)
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faEdit}
                                            className=' far'
                                            data-prefix='far'
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  )
                                )
                              ) : (
                                <label className='latest-update'>
                                  No saved filters
                                </label>
                              )}
                            </div>
                          </Row>
                        </Row>
                      </div>
                    ) : null}
                  </Content>
                </DefaultModal>
              ) : null}
              {/* Select in courses if access or second access is 2 */}
              {managerReport.selectedTab === 'courses' &&
              (user.access === 2 || user.second_access === 2) ? (
                <div className='row'>
                  <div className='col-4 pr-0 pl-0 multiline-wrapper'>
                    <Select
                      options={props?.roles}
                      selectedOptions={managerReport.selectedCoursesRole || {}}
                      onChange={(e) =>
                        dispatch(selectCoursesRoleCourseManager(e))
                      }
                      placeholder='Select Role'
                      multi={true}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          background: '#fff',
                          borderColor: '#9e9e9e',
                          minHeight: '30px',
                          height: '30px',
                          fontSize: '14px',
                          boxShadow: state.isFocused ? null : null,
                        }),

                        valueContainer: (provided) => ({
                          ...provided,
                          height: '30px',
                          padding: '0 6px',
                        }),

                        input: (provided) => ({
                          ...provided,
                          margin: '0px',
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: '30px',
                        }),
                      }}
                    />
                  </div>
                  <div>
                    <button
                      title={`Export to .csv`}
                      className={`btn btn-download btn-transparent`}
                      onClick={() => dispatch(onClickExportButton())}
                    >
                      {/* <FontAwesomeIcon icon={faFileCsv} size={"2x"} /> */}
                    </button>
                  </div>
                </div>
              ) : null}

              {/* Filter button in groups */}
              {managerReport.selectedTab === 'groups' &&
              (user.access === 1 ||
                user.access === 4 ||
                user.access === 5 ||
                user.second_access === 4) ? (
                <button
                  title={`Export to .csv`}
                  className='btn btn-info filters__button shadow-none'
                  onClick={() => {
                    setApprovalModal(true)
                    dispatch(setShowGroupsFiltersOverlay(true))
                  }}
                >
                  {language.manager_report
                    ? language.manager_report.filters
                    : null}
                </button>
              ) : null}
              {/* Modal in groups */}
              {managerReport.groupsFilterOveralyShowing && filterModal ? (
                <DefaultModal
                  isOpen={filterModal}
                  selectedTab={managerReport.selectedTab}
                  setApprovalModal={setApprovalModal}
                  title='Filters'
                >
                  <div style={{ overflow: 'hidden' }}>
                    {managerReport.selectedTab === 'groups' &&
                    (user.access === 1 ||
                      user.access === 5 ||
                      user.second_access === 5) ? (
                      <FilterWrapperCourseGroups
                        {...props}
                        filterType={filterType}
                        filterName={filterName}
                        item={item}
                        setFilterName={setFilterName}
                        setFilterType={setFilterType}
                        setItem={setItem}
                        managerReport={managerReport}
                        // stores={stores}
                      />
                    ) : null}
                    {managerReport.selectedTab === 'groups' &&
                    (user.access === 4 || user.second_access === 4) ? (
                      <div className='overlay-content filters-wrapper'>
                        <div
                          onClick={
                            filterType === 1
                              ? () => dispatch(clearGroupsFilter())
                              : ''
                          }
                        >
                          <p
                            onClick={
                              filterType === 1 ? () => setFilterType(0) : ''
                            }
                            className={
                              filterType === 0
                                ? 'mr-courses-select-filters'
                                : 'btn-info'
                            }
                          >
                            {filterType === 0
                              ? 'Select filters'
                              : `Cancel Edit`}
                          </p>
                        </div>
                        <div className='filter-type'>
                          {filterType === 1
                            ? `Editing Filter: ${filterName}`
                            : ''}
                        </div>

                        <div className='row filters-content'>
                          <div className='col-md-6'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={sortByName(
                                  props.groups.locationGroups
                                )}
                                selectedOptions={
                                  managerReport.selectedGroupsGroup || null
                                }
                                onChange={(e) => dispatch(selectGroupsGroup(e))}
                                placeholder={'Select group'}
                                multi={false}
                                valueKey={'name'}
                              />
                            </div>
                          </div>

                          <div className='col-md-6'>
                            <div
                              className={`${
                                props.type === 'groups'
                                  ? 'multiline-wrapper-groups'
                                  : 'multiline-wrapper'
                              }`}
                            >
                              <Select
                                options={
                                  managerReport.selectedGroupsGroup
                                    ? managerReport.groupGroupsLocations
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedGroupsLocations || null
                                }
                                onChange={(e) =>
                                  dispatch(selectGroupsLocation(e))
                                }
                                placeholder={'Select location'}
                              />
                            </div>
                          </div>

                          <div className='col-md-6 mt-3 mb-3'>
                            <div
                              className={`${
                                props.type === 'groups'
                                  ? 'multiline-wrapper-groups'
                                  : 'multiline-wrapper'
                              }`}
                            >
                              <Select
                                options={
                                  managerReport.selectedGroupsGroup
                                    ? sortByName(
                                        managerReport.locationGroupCourses
                                      )
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedGroupGroupsLocations ||
                                  null
                                }
                                onChange={(e) =>
                                  dispatch(
                                    selectGroupsLocationGroupCourse(
                                      e.target.value
                                    )
                                  )
                                }
                                placeholder={'Select curriculum'}
                                multi={true}
                              />
                            </div>
                          </div>
                          <div className='col-md-6 mt-3 mb-3'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={
                                  managerReport.selectedGroupsGroup &&
                                  (managerReport.selectedGroupsLocations
                                    .length ||
                                    managerReport.selectedGroupGroupsLocations)
                                    ? managerReport.rolesCount
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedGroupsRole || []
                                }
                                onChange={(e) => dispatch(selectGroupsRole(e))}
                                placeholder={'Select role'}
                                multi={true}
                              />
                            </div>
                          </div>
                        </div>
                        <Row className='mt-2 align-content-right'>
                          <button
                            className={`btn btn-clear-filters 
                                    ${
                                      managerReport.selectedGroupsGroup ||
                                      managerReport.selectedGroupsLocations
                                        .length ||
                                      managerReport.selectedGroupGroupsLocations ||
                                      managerReport.selectedGroupsRole.length ||
                                      managerReport.selectedGroupsSavedFilter
                                        ? ''
                                        : 'btn-disabled'
                                    }`}
                            disabled={
                              managerReport.selectedGroupsGroup ||
                              managerReport.selectedGroupsLocations.length ||
                              managerReport.selectedGroupGroupsLocations ||
                              managerReport.selectedGroupsRole.length ||
                              managerReport.selectedGroupsSavedFilter
                                ? false
                                : true
                            }
                            onClick={() => dispatch(clearGroupsFilter())}
                          >
                            Clear filters
                          </button>
                          <button
                            className={`btn btn-info
                                      ${
                                        managerReport.selectedGroupsGroup &&
                                        managerReport.selectedGroupGroupsLocations
                                          ? ''
                                          : 'btn-disabled'
                                      }`}
                            onClick={() => dispatch(setGroupsFilter())}
                            disabled={
                              managerReport.selectedGroupsGroup &&
                              managerReport.selectedGroupGroupsLocations
                                ? false
                                : true
                            }
                          >
                            Apply filters
                          </button>
                          <button
                            className={`btn btn-info btn-save-filter
                                      ${
                                        managerReport.selectedGroupsGroup &&
                                        managerReport.selectedGroupGroupsLocations
                                          ? ''
                                          : 'btn-disabled'
                                      }`}
                            onClick={
                              filterType === 0
                                ? () => dispatch(saveGroupsFilter())
                                : () => dispatch(saveEditedGroupsFilter(item))
                            }
                            disabled={
                              managerReport.selectedGroupsGroup &&
                              managerReport.selectedGroupGroupsLocations
                                ? false
                                : true
                            }
                          >
                            Save filter
                          </button>
                        </Row>
                        <Row className='mt-2'>
                          <p>Saved filters:</p>
                        </Row>
                        <Row>
                          <div className='course-list-wrapper w-100'>
                            {managerReport.savedGroupsFilters.length ? (
                              managerReport.savedGroupsFilters.map((item) => (
                                <div className='course-row' key={item.id}>
                                  <p className='mb-0'>{item.name}</p>
                                  <div className='course-item-options'>
                                    <button
                                      onClick={() =>
                                        dispatch(deleteSavedFilter(item.id))
                                      }
                                      title={`Delete`}
                                      className='btn  btn-transparent'
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        className='far'
                                      />
                                    </button>

                                    <span
                                      onClick={() => {
                                        dispatch(
                                          editCourseGroupFilter(
                                            item,
                                            props.roles
                                          )
                                        )
                                        // setFilterType(1);
                                        setItem(item)
                                        setFilterName(item.name)
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faEdit}
                                        className='far'
                                        data-prefix='far'
                                      />
                                    </span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <label className='latest-update'>
                                No saved filters
                              </label>
                            )}
                          </div>
                        </Row>
                      </div>
                    ) : null}
                  </div>
                </DefaultModal>
              ) : null}
              {/* Selects in groups if access or second access is 2 */}
              {managerReport.selectedTab === 'groups' &&
              (user.access === 2 || user.second_access === 2) ? (
                <div className='row'>
                  <div className='col-4'>
                    <div
                      className={`${
                        props.type === 'groups'
                          ? 'multiline-wrapper-groups'
                          : 'multiline-wrapper'
                      }`}
                    >
                      <Select
                        options={sortByName(
                          managerReport.courseManagerGroupsLocationGroups
                        )}
                        selectedOptions={
                          managerReport.selectedCourseManagerGroupsLocationGroups ||
                          null
                        }
                        onChange={() =>
                          dispatch(
                            selectCourseManagerGroupsLocationGroupCourse()
                          )
                        }
                        placeholder={'Select curriculum'}
                        multi={false}
                      />
                    </div>
                  </div>

                  <div className='col-4'>
                    <div className='multiline-wrapper'>
                      <Select
                        options={
                          managerReport.selectedCourseManagerGroupsLocationGroups
                            ? sortByName(props.roles)
                            : []
                        }
                        selectedOptions={managerReport.selectedGroupsRole || []}
                        onChange={(e) =>
                          dispatch(selectGroupsRoleCourseManager(e))
                        }
                        placeholder={'Select role'}
                      />
                    </div>
                  </div>
                  <div className='col-1'>
                    <button
                      title={`"Export to " .csv`}
                      className={`btn btn-download btn-transparent ${
                        managerReport.exportTrainingButton ? '' : 'disabled'
                      }`}
                      onClick={
                        managerReport.exportTrainingButton
                          ? dispatch(onClickCourseManagerExportTrainingButton())
                          : null
                      }
                    >
                      <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                    </button>
                  </div>
                </div>
              ) : null}
              {/* Filter button in external reports */}
              {managerReport.selectedTab === 'external-reports' &&
              (user.access === 1 ||
                user.access === 4 ||
                user.access === 5 ||
                user.second_access === 4) ? (
                <button
                  title={`Export to .csv`}
                  className='btn btn-info filters__button shadow-none'
                  onClick={() => {
                    setApprovalModal(true)
                    dispatch(setShowExternalReportsFiltersOverlay(true))
                  }}
                >
                  {language.manager_report
                    ? language.manager_report.filters
                    : null}
                </button>
              ) : null}
              {/* Modal in external reports */}
              {managerReport.externalReportsFilterOveralyShowing &&
              filterModal ? (
                <DefaultModal
                  isOpen={filterModal}
                  selectedTab={managerReport.selectedTab}
                  setApprovalModal={setApprovalModal}
                  title='Filters'
                >
                  <Content style={{ overflow: 'hidden' }}>
                    {managerReport.selectedTab === 'external-reports' &&
                    (user.access === 1 ||
                      user.access === 5 ||
                      user.second_access === 5) ? (
                      <FilterWrapperExternalReports
                        {...props}
                        filterType={filterType}
                        filterName={filterName}
                        item={item}
                        setItem={setItem}
                        setFilterName={setFilterName}
                        setFilterType={setFilterType}
                        managerReport={managerReport}
                        // stores={stores}
                      />
                    ) : null}

                    {managerReport.selectedTab === 'external-reports' &&
                    (user.access === 4 || user.second_access === 4) ? (
                      <div className='overlay-content filters-wrapper'>
                        <div
                          onClick={
                            filterType === 1
                              ? () => dispatch(clearExternalReportsFilter())
                              : null
                          }
                        >
                          <p
                            onClick={
                              filterType === 1 ? () => setFilterType(0) : null
                            }
                            className={
                              filterType === 0
                                ? 'mr-courses-select-filters'
                                : 'btn-info'
                            }
                          >
                            {filterType === 0
                              ? 'Select filters'
                              : `Cancel Edit`}
                          </p>
                        </div>
                        <div className='filter-type'>
                          {filterType === 1
                            ? `Editing Filter: ${filterName}`
                            : ''}
                        </div>
                        <Row className=' filters-content'>
                          <div className='col-md-3'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={sortByName(managerReport.areas)}
                                selectedOptions={
                                  managerReport.selectedExternalReportsGroup ||
                                  null
                                }
                                onChange={(e) =>
                                  dispatch(selectExternalReportsGroup(e))
                                }
                                placeholder={'Select group'}
                                multi={false}
                                valueKey={'name'}
                              />
                            </div>
                          </div>
                          <div className='col-md-5'>
                            <div
                              className={`${
                                props.type === 'groups'
                                  ? 'multiline-wrapper-groups'
                                  : 'multiline-wrapper'
                              }`}
                            >
                              <Select
                                options={
                                  managerReport.selectedExternalReportsGroup
                                    ? managerReport.groupLocations
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedExternalReportsLocations ||
                                  null
                                }
                                onChange={(e) =>
                                  dispatch(selectExternalReportsLocation(e))
                                }
                                placeholder={'Select location'}
                                // language={props.language}
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className='multiline-wrapper'>
                              <Select
                                options={
                                  managerReport.selectedExternalReportsGroup &&
                                  managerReport.selectedExternalReportsLocations
                                    .length
                                    ? managerReport.rolesCount
                                    : null
                                }
                                selectedOptions={
                                  managerReport.selectedExternalReportsRole ||
                                  []
                                }
                                onChange={(e) =>
                                  dispatch(selectExternalReportsRole(e))
                                }
                                placeholder={'Select role'}
                              />
                            </div>
                          </div>
                        </Row>

                        <div className='row align-content-right'>
                          <button
                            className={`btn btn-clear-filters 
                                    ${
                                      managerReport.selectedExternalReportsGroup ||
                                      managerReport
                                        .selectedExternalReportsLocations
                                        .length ||
                                      managerReport.selectedExternalReportsRole
                                        .length ||
                                      managerReport.selectedExternalReportsSavedFilter
                                        ? ''
                                        : 'btn-disabled'
                                    }`}
                            disabled={
                              managerReport.selectedExternalReportsGroup ||
                              managerReport.selectedExternalReportsLocations
                                .length ||
                              managerReport.selectedExternalReportsRole
                                .length ||
                              managerReport.selectedExternalReportsSavedFilter
                                ? false
                                : true
                            }
                            onClick={() =>
                              dispatch(clearExternalReportsFilter())
                            }
                          >
                            {'Clear filters'}
                          </button>
                          <button
                            className={`btn btn-info
                                  ${
                                    managerReport.selectedExternalReportsGroup &&
                                    managerReport
                                      .selectedExternalReportsLocations.length
                                      ? ''
                                      : 'btn-disabled'
                                  }`}
                            onClick={() => dispatch(setExternalReportsFilter())}
                            disabled={
                              managerReport.selectedExternalReportsGroup &&
                              managerReport.selectedExternalReportsLocations
                                .length
                                ? false
                                : true
                            }
                          >
                            Apply filters
                          </button>
                          <button
                            className={`btn btn-info btn-save-filter
                                      ${
                                        managerReport.selectedExternalReportsGroup &&
                                        managerReport
                                          .selectedExternalReportsLocations
                                          .length
                                          ? ''
                                          : 'btn-disabled'
                                      }`}
                            onClick={
                              filterType === 0
                                ? () => dispatch(saveExternalReportsFilter())
                                : () => dispatch(saveEditedFilter(item))
                            }
                            disabled={
                              managerReport.selectedExternalReportsGroup &&
                              managerReport.selectedExternalReportsLocations
                                .length
                                ? false
                                : true
                            }
                          >
                            Save filter
                          </button>
                        </div>
                        <Row className='ml-0 mr-0 mt-2'>
                          <p>Saved filters:</p>
                        </Row>
                        <Row>
                          <div className='course-list-wrapper w-100'>
                            {managerReport.savedExternalReportsFilters
                              .length ? (
                              managerReport.savedExternalReportsFilters.map(
                                (item) => (
                                  <div className='course-row' key={item.id}>
                                    <p className='mb-0'>{item.name}</p>
                                    <div className='course-item-options'>
                                      <button
                                        onClick={() =>
                                          dispatch(deleteSavedFilter(item.id))
                                        }
                                        title={`Delete`}
                                        className='btn  btn-transparent'
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          className='far'
                                        />
                                      </button>
                                      <span
                                        onClick={() => {
                                          dispatch(
                                            selectEditGroupAndLocationsExternalReports(
                                              item,
                                              props.roles
                                            )
                                          )
                                          setFilterType(1)
                                          setItem(item)
                                          setFilterName(item.name)
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faEdit}
                                          className='far'
                                          data-prefix='far'
                                        />
                                      </span>
                                    </div>
                                  </div>
                                )
                              )
                            ) : (
                              <label className='latest-update'>
                                No saved filters
                              </label>
                            )}
                          </div>
                        </Row>
                      </div>
                    ) : null}
                  </Content>
                </DefaultModal>
              ) : null}
              {/* Selects in external reports if access or second access is 2 */}
              {managerReport.selectedTab === 'external-reports' &&
              (user.access === 2 || user.second_access === 2) ? (
                <div className='row'>
                  <div className='col-3'>
                    <div className='multiline-wrapper'>
                      <Select
                        options={props.roles}
                        selectedOptions={
                          managerReport.selectedExternalReportsRole || []
                        }
                        onChange={(e) =>
                          dispatch(selectCoursesRoleCourseManager(e))
                        }
                        placeholder={'Select role'}
                      />
                    </div>
                  </div>
                  <div className='col-1'>
                    <button
                      title={`"Export to " .csv`}
                      className={`btn btn-download btn-transparent`}
                      onClick={() => dispatch(onClickExportButton())}
                    >
                      <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {/* Select filters  */}
          {user.access === 1 ||
          user.access === 4 ||
          user.access === 5 ||
          user.second_access === 4 ? (
            managerReport.selectedTab === 'courses' ? (
              <div className='filters-select ml-2 col-sm-4 col-xs-8 col-lg-5'>
                <Select
                  options={managerReport.savedCoursesFilters || []}
                  selectedOptions={
                    managerReport.selectedCoursesSavedFilter || null
                  }
                  onChange={(e) => dispatch(selectCoursesSavedFilter(e))}
                  placeholder={`${
                    language.manager_report
                      ? language.manager_report.select_filters
                      : null
                  }`}
                  multi={false}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      background: '#fff',
                      borderColor: '#9e9e9e',
                      minHeight: '34px',
                      height: '34px',
                      fontSize: '12px',
                      boxShadow: state.isFocused ? null : null,
                    }),

                    valueContainer: (provided, state) => ({
                      ...provided,
                      height: '34px',
                      padding: '0 6px',
                    }),

                    input: (provided, state) => ({
                      ...provided,
                      margin: '0px',
                    }),
                    indicatorsContainer: (provided, state) => ({
                      ...provided,
                      height: '34px',
                    }),
                  }}
                />
              </div>
            ) : managerReport.selectedTab === 'groups' ? (
              <div className='filters-select ml-2 col-md-4 col-xs-8 col-lg-5'>
                <Select
                  options={managerReport.savedGroupsFilters || []}
                  selectedOptions={
                    managerReport.selectedGroupsSavedFilter || null
                  }
                  onChange={(e) => dispatch(selectGroupsSavedFilter(e))}
                  placeholder={`${
                    language.manager_report
                      ? language.manager_report.select_filters
                      : null
                  }`}
                  multi={false}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      background: '#fff',
                      borderColor: '#9e9e9e',
                      minHeight: '34px',
                      height: '34px',
                      fontSize: '12px',

                      boxShadow: state.isFocused ? null : null,
                    }),

                    valueContainer: (provided) => ({
                      ...provided,
                      height: '34px',
                      padding: '0 6px',
                    }),

                    input: (provided) => ({
                      ...provided,
                      margin: '0px',
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: '34px',
                    }),
                  }}
                />
              </div>
            ) : (
              <div className='filters-select ml-2 col-md-4 col-xs-8 col-lg-5'>
                <Select
                  options={managerReport.savedExternalReportsFilters || []}
                  selectedOptions={
                    managerReport.selectedExternalReportsSavedFilter || null
                  }
                  onChange={(e) =>
                    dispatch(selectExternalReportsSavedFilter(e))
                  }
                  placeholder={`${
                    language.manager_report
                      ? language.manager_report.select_filters
                      : null
                  }`}
                  multi={false}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      background: '#fff',
                      borderColor: '#9e9e9e',
                      minHeight: '34px',
                      height: '34px',
                      fontSize: '12px',
                      boxShadow: state.isFocused ? null : null,
                    }),

                    valueContainer: (provided) => ({
                      ...provided,
                      height: '34px',
                      padding: '0 6px',
                    }),

                    input: (provided) => ({
                      ...provided,
                      margin: '0px',
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: '34px',
                    }),
                  }}
                />
              </div>
            )
          ) : null}
          <>
            {/* {managerReport.selectedTab === 'courses' && (
              <div
                className={'ps-2 view-charts'}
                style={{ marginLeft: 20, marginTop: 2 }}
              >
                {showingChart === true &&
                (managerReport.groupsRows.length ||
                  managerReport.coursesRows.length) ? (
                  <button
                    id='chart-span-hide'
                    onClick={() => setShowingChart(false)}
                    className='btn show-table-icon font-weight-bold'
                  >
                    Hide Charts
                  </button>
                ) : (
                  <button
                    id='chart-span-view'
                    className={`btn font-weight-bold show-table-icon   ${
                      !activateCharts ? ' disabled-charts' : ''
                    }`}
                    onClick={
                      (managerReport.groupsRows.length &&
                        managerReport.selectedTab === 'groups') ||
                      (managerReport.coursesRows.length &&
                        managerReport.selectedTab === 'courses') ||
                      (managerReport.externalReportsRows.length &&
                        managerReport.selectedTab === 'external-reports')
                        ? () => setShowingChart(true)
                        : null
                    }
                  >
                    View Charts
                  </button>
                )}
              </div>
            )} */}

            {/* <div className='pt-2'>
              {managerReport.selectedTab === 'courses' ? (
                <ManagerReportCourses
                  showingChart={showingChart}
                  managerUsers={managerUsers}
                  {...props}
                />
              ) : managerReport.selectedTab === 'groups' ? (
                <ManagerReportGroups
                  showingChart={showingChart}
                  managerUsers={managerUsers}
                  {...props}
                />
              ) : (
                <ManagerReportExternalReports
                  showingChart={showingChart}
                  managerUsers={managerUsers}
                  {...props}
                />
              )}
            </div> */}
          </>

          {/* Export to .csv icon */}
          {/* {user.access === 1 ||
					user.access === 4 ||
					user.access === 5 ||
					user.second_access === 4 ? (
						managerReport.selectedTab === 'courses' ? (
							<div className='col-1 pl-0'>
								<button
									title={`Export to .csv`}
									className={`btn btn-download pl-1 btn-transparent  ${
										managerReport.exportButton ? '' : 'disabled'
									}`}
									// onClick={
									//   managerReport.exportButton
									//     ? dispatch(onClickExportButton())
									//     : null
									// }
								>
									<FontAwesomeIcon icon={faFileCsv} size={'2x'} />
									rss
								</button>
							</div>
						) : managerReport.selectedTab === 'groups' ? (
							<div>
								<button
									title={`Export to .csv`}
									className={`btn btn-download pl-1 btn-transparent ${
										managerReport.exportTrainingButton ? '' : 'disabled'
									}`}
									// onClick={
									//   managerReport.exportExternalReportsButton
									//     ? dispatch(onClickExportTrainingButton())
									//     : null
									// }
								>
									<FontAwesomeIcon icon={faFileCsv} size={'2x'} />
								</button>
							</div>
						) : (
							<div>
								<button
									title={`Export to .csv`}
									className={`btn btn-download pl-1 btn-transparent ${
										managerReport.exportExternalReportsButton ? '' : 'disabled'
									}`}
									// onClick={
									//   managerReport.exportExternalReportsButton
									//     ? dispatch(onClickExportExternalReportsButton())
									//     : null
									// }
								>
									<FontAwesomeIcon icon={faFileCsv} size={'2x'} />
								</button>
							</div>
						)
					) : null} */}
        </div>
        {/* Search bar */}
        <div className='col-md-4 col-sm-12 px-0 mt-3 mt-lg-0'>
          <div className='d-flex align-items-baseline justify-content-between justify-content-sm-end '>
            {user.access === 1 ||
            user.access === 4 ||
            user.access === 5 ||
            user.second_access === 4 ? (
              managerReport.selectedTab === 'courses' ? (
                <div className='mr-4'>
                  <button
                    title={`Export to .csv`}
                    className={`btn btn-download pl-1 btn-transparent ${
                      managerReport.exportButton ? '' : 'disabled'
                    }`}
                    onClick={handleExportButtonClick}
                  >
                    <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                  </button>
                </div>
              ) : managerReport.selectedTab === 'groups' ? (
                <div className='mr-2'>
                  <button
                    title={`Export to .csv`}
                    className={`btn btn-download pl-1 btn-transparent ${
                      managerReport.exportTrainingButton ? '' : 'disabled'
                    }`}
                    onClick={handleExportTrainingButtonClick}
                  >
                    <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                  </button>
                </div>
              ) : (
                <div className='mr-2'>
                  <button
                    title={`Export to .csv`}
                    className={`btn btn-download pl-1 btn-transparent ${
                      managerReport.exportExternalReportsButton
                        ? ''
                        : 'disabled'
                    }`}
                    onClick={handleExportExternalReportsButtonClick}
                  >
                    <FontAwesomeIcon icon={faFileCsv} size={'2x'} />
                  </button>
                </div>
              )
            ) : null}
            {/* shabani */}
            <div className='d-flex flex-column col-8 px-0'>
              <Search
                placeholder={language.general ? language.general.search : null}
                value={managerReport.searchValue || ''}
                onChange={(e) => dispatch(search(e.target.value))}
                onClick={() => dispatch(onClickSearch())}
                onXClick={() => {
                  dispatch(search(''))
                  dispatch(onClickSearch())
                }}
                handleKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    dispatch(onClickSearch())
                  }
                  if (
                    event.key === 'Backspace' &&
                    managerReport.searchValue.length === 1
                  ) {
                    dispatch(search(''))
                    dispatch(onClickSearch())
                  }
                }}
              />
              <div className='search-options-wrapper d-flex'>
                <div className='custom-control custom-radio dashboard-radio mr-2'>
                  <input
                    className='custom-control-input bg-default'
                    name='search-by-data'
                    id='search-by-data'
                    checked={managerReport.searchByData || false}
                    onChange={() => dispatch(setSearchByData())}
                    type='radio'
                  />
                  <label
                    className='custom-control-label'
                    style={{
                      paddingTop: '1px',
                    }}
                    htmlFor='search-by-data'
                  >
                    {language.general ? language.general.name : null}
                  </label>
                </div>

                <div className='custom-control custom-radio dashboard-radio mr-2'>
                  <input
                    className='custom-control-input bg-default'
                    name='search-by-header'
                    id='search-by-header'
                    checked={managerReport.searchByHeader || false}
                    onChange={() => dispatch(setSearchByHeader())}
                    type='radio'
                  />
                  <label
                    className='custom-control-label'
                    style={{ paddingTop: '1px' }}
                    htmlFor='search-by-header'
                  >
                    {language.manager_report
                      ? language.manager_report.training
                      : null}
                  </label>
                </div>

                {managerReport.selectedTab === 'courses' && (
                  <div className='custom-control custom-checkbox-light border-light d-inline'>
                    <input
                      type='checkbox'
                      className='custom-control-input'
                      name='search-by-core'
                      id='search-by-core'
                      checked={managerReport.searchByCore || false}
                      onChange={(e) =>
                        dispatch(setSearchByCore(e.target.checked))
                      }
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='search-by-core'
                    >
                      core
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Row>
    </Col>
  )
}
